<div class="container">
      <h1 class="page-title">
    <span class="icon"><i class="fas fa-cog"></i></span>{{ 'Menu.Menu.FSCSSCSetting' | translate }}</h1>
  <p-card>
      <form class="detail-form" [formGroup]="editForm">
        <div class="field grid">
          <div class="p-fluid field grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">流水號</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.seqNo | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">貨代</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="forwarder" [filter]="true" [options]="forwarderOptions" [(ngModel)]="airwaysExpense.forwarder"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.forwarder.touched) && editForm.controls.forwarder.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">費用別</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="feeType" [filter]="true" [options]="feeTypeOptions" [(ngModel)]="airwaysExpense.feeType"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.feeType.touched) && editForm.controls.feeType.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">幣別</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="currency" [filter]="true" [options]="currencyOptions" [(ngModel)]="airwaysExpense.currency"></p-dropdown>
                <small
                  *ngIf="((submitted || editForm.controls.currency.touched) && editForm.controls.currency.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
                </small>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">狀態</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.status | optionsMapping:statusOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">出發國家</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="fromCountry" [filter]="true" [options]="countryOptions" [(ngModel)]="airwaysExpense.fromCountry"></p-dropdown>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">目的 IATA 區域</label>
              <div class="col-8 column-value">
                <p-dropdown formControlName="toIataArea" [filter]="true" [options]="iataAreaOptions" [(ngModel)]="airwaysExpense.toIataArea"></p-dropdown>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">金額(每公斤)</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="amount" [(ngModel)]="airwaysExpense.amount" mode="decimal" [minFractionDigits]="4" [maxFractionDigits]="4" [maxlength]="22"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">是否有效</label>
              <div class="col-8 column-value">
                <p-radioButton formControlName="isActivated" name="isActivated" value="1" label="Y" [(ngModel)]="airwaysExpense.isActivated"></p-radioButton>
                <p-radioButton formControlName="isActivated" name="isActivated" value="0" label="N" [(ngModel)]="airwaysExpense.isActivated" class="ml-2"></p-radioButton>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">生效日起</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="startDtTimeZone" [(ngModel)]="airwaysExpense.startDtTimeZone"></p-calendar>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">生效日迄</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="endDtTimeZone" [(ngModel)]="airwaysExpense.endDtTimeZone"></p-calendar>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">備註</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="remark" [(ngModel)]="airwaysExpense.remark" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline"></div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">建立者</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.createUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">建立時間</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">更新者</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.updateUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">更新時間</label>
              <div class="col-8 column-value">
                {{ airwaysExpense?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick($event)" class="mr-2"></button>
              <button pButton pRipple label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}" (click)="goToLastPage()" class="mr-2"></button>
            </div>
          </div>
        </div>
      </form>
  </p-card>
</div>
